<template>
    <div class="service-management">
        <h1>Service Management</h1>
        <div class="services">
            <div v-for="service of services" :key="'service-' + service.service" class="service">
                <c-switch v-if="service.service != 'DEFAULT'" @change.native="swtichService(service.turnedOn, service.service)" v-model="service.turnedOn" class="mx-1" color="primary"  variant="3d" dataOn="✓" dataOff="✕" data-checked="Dark" label />
                <label v-if="service.service != 'DEFAULT'">{{service.displayName}}</label>
                <div class="info">
                    <i class="fa fa-info-circle"></i>
                    <p>{{service.description}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios'
import globalStore from "../../variables";
import { Switch as cSwitch } from "@coreui/vue";

export default {
    name: "ServiceManagement",
    components: {cSwitch},
    data() {
        return {
            services: []
        }
    },
    methods: {
        getServices() {
            Axios.get(globalStore.data.restApiUrl + '/admin/service')
                .then(response => {
                    this.services = response.data
                })
        },
        swtichService(status, service) {
            if(status) {
                this.turnOnService(service)
            } else {
                this.turnOffService(service)
            }
        },
        turnOnService(service) {
            Axios.post(globalStore.data.restApiUrl + '/admin/service/turn-on?services=' + service)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Service turned on',
                        text: 'You successful turned on ' + service + ' service.',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Service turning on error',
                        text: 'An error has occured during turning on ' + service + ' service.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        turnOffService(service) {
            Axios.post(globalStore.data.restApiUrl + '/admin/service/turn-off?services=' + service)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Service turned off',
                        text: 'You successful turned off ' + service + ' service.',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Service turning off error',
                        text: 'An error has occured during turning off ' + service + ' service.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        }
    },
    mounted() {
        this.getServices()
    }
}
</script>

<style lang="scss">
    .service-management {
        padding: 20px;
        background-color: #fff;
        border: 1px solid #C9CFD4;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        h1 {
            margin: 0 0 25px;
            font-size: 15px;
            font-weight: 700;
        }
        .services {
            display: flex;
            flex-direction: column;
            gap: 20px 0;
        }
        .service {
            display: flex;
            align-items: center;
            gap: 0 30px;
            label {
                margin: 0;
                &.disabled {
                    opacity: 0.7;
                }
            }
            .info {
                position: relative;
                p {
                    position: absolute;
                    left: calc(100% + 12px);
                    display: none;
                    min-width: 300px;
                    padding: 12px;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    background-color: #fff;
                    border: 1px solid #C9CFD4;
                    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
                    z-index: 10;
                }
                i {
                    color: #a6aaac;
                    cursor: pointer;
                    &:hover {
                        +p {
                            display: initial;
                        }
                    }
                }
            }
        }
    }
</style>